/** All-time / This-FY segmented toggle shared by the POSP holistic-profile
 *  pages (POSPDetailPage self-service, ChannelDetailPage's POSP branch).
 *  Item 14 (QA round-2): both profiles default to the current financial year
 *  (Apr–Mar) and let the viewer flip to an unfiltered all-time view — the same
 *  ?period=fy|all the backend already supports on /policies/ and
 *  /earnings_summary/, so this is purely a display toggle over one query param. */
export type ProfilePeriod = 'fy' | 'all';

export function PeriodToggle({
  period,
  onChange,
}: {
  period: ProfilePeriod;
  onChange: (period: ProfilePeriod) => void;
}) {
  const options: { value: ProfilePeriod; label: string }[] = [
    { value: 'fy', label: 'This FY' },
    { value: 'all', label: 'All-time' },
  ];

  return (
    <div className="inline-flex rounded-lg border border-gray-200 dark:border-gray-700 p-0.5 bg-gray-50 dark:bg-gray-700/50">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${
            period === opt.value
              ? 'bg-white dark:bg-gray-800 text-primary-700 dark:text-primary-400 shadow-sm'
              : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'
          }`}
          aria-pressed={period === opt.value}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
